import coverImg from "assets/images/v137/cover.webp"
import titleImg from "assets/images/v137/title.webp"

export const v137Config = {
  cover: {
    en: coverImg,
  },
  title: {
    en: titleImg,
  },
}
